import { deleteOrganisation } from '../../../../../predict/src/core/api/organisations';
import { queryClient } from '../../../../core/queryClient';
import { workspacesListingQueryKey } from '../../queries/workspacesListingQuery';
import { createMutation } from '../../../../utils/mutations';

interface DeleteOrganisationInput {
  workspaceId: string;
  organisationId: string;
}

/**
 * Mutation to delete an organisation from a workspace.
 * Invalidates the workspace listing query cache on successful deletion.
 *
 * @example
 * const mutation = deleteOrganisationMutation();
 * mutation.mutate({ workspaceId: 'ws-123', organisationId: 'org-456' });
 */
export const deleteOrganisationMutation = () =>
  createMutation<DeleteOrganisationInput, void>({
    mutationFn: ({ workspaceId, organisationId }) => deleteOrganisation(workspaceId, organisationId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: workspacesListingQueryKey() });
    }
  });
